
<template>
    <b-row class="mb-2">
        <b-col>{{
            $_getDownloadItemTitle(query.name)
        }}</b-col>
        <b-col cols="auto">
            <base-button
                variant="primary"
                @click="$_startDownload"
                :disabled="!themeProfiles"
                :text="$t('dashboard.statistieken.downloadStatistics')"
            />
        </b-col>
    </b-row>
</template>
<script>
    import { mapActions } from 'vuex';
    import { PROFILE_TYPE } from '../../../../constants';
    import BaseButton from '../../../BaseComponents/base-button.vue';

    export default {
        components: { 'base-button': BaseButton },

        props: {
            organizationId: { type: Number, required: true },
            query: { type: Object, required: true },
            start: { type: Date, required: true },
            end: { type: Date, required: true }
        },

        data: function () {
            return { queryResult: null, themeProfiles: null };
        },

        created() {
            this.init();
        },

        computed: {
            tableSettings() {
                return JSON.parse(this.query.responseTemplate.replace(/\\"/g, '"'));
            },
            columns() {
                return this.tableSettings.columns;
            },
            exportData() {
                if (!this.queryResult) {
                    return null;
                }
                // list of irrelevant columns
                const ignoreColumns = [
                    'context',
                    'usage',
                    'isAdmin',
                    'isFeedbackEditor',
                    'isSuper',
                    'operation_Name',
                    'operation_Id',
                    'operation_ParentId',
                    'operation_SyntheticSource',
                    'session_Id',
                    'user_Id',
                    'user_AuthenticatedId',
                    'user_AccountId',
                    'application_Version',
                    'client_Type',
                    'client_Model',
                    'cloud_RoleName',
                    'cloud_RoleInstance',
                    'appId',
                    'appName',
                    'iKey',
                    'sdkVersion',
                    '_ResourceId'
                ];
                // list of columns
                const columns = this.columns;
                return (
                    this.queryResult
                        // make json from the data (is string)
                        .map(({ logData }) => JSON.parse(logData))
                        // make objects of datapoints using columnnames
                        .map((row) => {
                            return columns.reduce((acc, item, index) => {
                                // parse dynamic columns
                                if (item.type === 'dynamic') {
                                    acc[item.name] = JSON.parse(row[index]);
                                    return acc;
                                }
                                acc[item.name] = row[index];
                                return acc;
                            }, {});
                        })
                        // flatten dynamic columns
                        .map((row) => {
                            return columns.reduce((acc, item) => {
                                if (item.type === 'dynamic') {
                                    // parse profiles array if present
                                    if (row[item.name]?.profiles) {
                                        row[item.name].profiles = JSON.parse(
                                            row[item.name].profiles
                                        );
                                    }
                                    return { ...acc, ...row[item.name] };
                                }
                                acc[item.name] = row[item.name];
                                return acc;
                            }, {});
                        })
                        // remove irrelevant columns
                        .map((row) => {
                            ignoreColumns.forEach((deleteProp) => {
                                row[deleteProp] !== undefined &&
                                    delete row[deleteProp];
                            });
                            return row;
                        })
                );
            },
            dataPerProfile() {
                if (!this.exportData || !this.themeProfiles) {
                    return null;
                }
                return this.themeProfiles.reduce((acc, profile) => {
                    const foundForProfile = this.exportData.filter((row) =>
                        row?.profiles?.includes(profile.id)
                    );
                    if (foundForProfile.length > 0) {
                        acc.push({
                            name: profile.name,
                            rows: foundForProfile
                        });
                    }
                    return acc;
                }, []);
            }
        },

        methods: {
            ...mapActions(['useApiData']),
            init() {
                this.getProfiles();
            },

            async getProfiles() {
                const profilesResult = await this.$store.dispatch('useApiData', {
                    name: 'GetProfileOverview',
                    parameters: { profileTypeId: PROFILE_TYPE.THEME_FEEDBACK }
                });
                this.themeProfiles = profilesResult?.data;
            },

            $_getQueryNameLastToken(queryName) {
                if (queryName === undefined) {
                    return null;
                }
                const tokens = queryName.split('.');
                return tokens[tokens.length - 1];
            },

            $_getDownloadItemTitle(queryName) {
                return this.$t(`dashboard.statistieken.downloads.${this.$_getQueryNameLastToken(queryName)}`);
            },

            async $_startDownload() {
                const logQueriesResult = await this.useApiData({
                    name: 'GetAnalyticsArchiveDownload',
                    data: {
                        name: this.query.name,
                        start: this.start,
                        end: this.end
                    }
                });
                this.queryResult = logQueriesResult.data;
                this.writeToExcel();
            },

            async writeToExcel() {
                if (!this.exportData) {
                    return;
                }

                const itemName = this.$_getQueryNameLastToken(this.query.name);
                const exportXlsx = await import('xlsx');
                const workBook = exportXlsx.utils.book_new();
                const fileName = this.query.name
                    ? `${itemName}.xlsx`
                    : 'export.xlsx';

                const data = exportXlsx.utils.json_to_sheet(this.exportData);
                exportXlsx.utils.book_append_sheet(workBook, data, itemName);
                this.dataPerProfile.forEach((item) => {
                    const profiledata = exportXlsx.utils.json_to_sheet(item.rows);
                    exportXlsx.utils.book_append_sheet(
                        workBook,
                        profiledata,
                        item.name
                    );
                });
                exportXlsx.writeFile(workBook, fileName);
            }
        }
    };
</script>

<style lang="scss" scoped>
h2 {
    width: 100%;
}
</style>
